import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './POSTAUCT_Occupancy_Eviction_Status.css';

const POSTAUCT_Occupancy_Eviction_Status = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"POSTAUCT_OCCUPANCY_EVICTION_STATUS",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	POSTAUCT_OCCUPANCY_EVICTION_STATUS:-1
  });


  const [POSTAUCT_OCCUPANCY_EVICTION_STATUS, setPOSTAUCT_OCCUPANCY_EVICTION_STATUS] = React.useState(null);
  const [POSTAUCT_OCCUPANCY_EVICTION_STATUS_D, setPOSTAUCT_OCCUPANCY_EVICTION_STATUS_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Post-Auction Occupancy and Eviction Status');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPOSTAUCT_OCCUPANCY_EVICTION_STATUS(clientInfo,"OpenNew");

		navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPOSTAUCT_OCCUPANCY_EVICTION_STATUS(clientInfo,"OpenNew");
		}
		navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
		if(Temp_Data2.status!="New"){
			handleDeletePOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data2);
			navigate('/POSTAUCT_Occupancy_Eviction_Status#New',{replace:true});
		} 
		else 
			navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Occupancy_Eviction_Status',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!POSTAUCT_OCCUPANCY_EVICTION_STATUS) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_${i}_SECTION`;
	  const headerId = `#POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [POSTAUCT_OCCUPANCY_EVICTION_STATUS]) ;


  
  
  var Ids = [];
  for(var Ele in POSTAUCT_OCCUPANCY_EVICTION_STATUS){
	  for(var Sec in POSTAUCT_OCCUPANCY_EVICTION_STATUS[Ele]){
		if(Sec == "id")
			Ids.push(POSTAUCT_OCCUPANCY_EVICTION_STATUS[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(POSTAUCT_OCCUPANCY_EVICTION_STATUS[Ele]["status"]);
		else if(Array.isArray(POSTAUCT_OCCUPANCY_EVICTION_STATUS[Ele][Sec]))
			  for(var Row in POSTAUCT_OCCUPANCY_EVICTION_STATUS[Ele][Sec])  // Convert to POSTAUCT_OCCUPANCY_EVICTION_STATUS[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in POSTAUCT_OCCUPANCY_EVICTION_STATUS[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["POSTAUCT_OCCUPANCY_EVICTION_STATUS"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPOSTAUCT_OCCUPANCY_EVICTION_STATUS(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_OCCUPANCY_EVICTION_STATUS`).then((response1) => {
		if(!POSTAUCT_OCCUPANCY_EVICTION_STATUS) 
			setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_OCCUPANCY_EVICTION_STATUS_D`).then((response2) => {
			setPOSTAUCT_OCCUPANCY_EVICTION_STATUS_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPOSTAUCT_OCCUPANCY_EVICTION_STATUS = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_OCCUPANCY_EVICTION_STATUS/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_OCCUPANCY_EVICTION_STATUS/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPOSTAUCT_OCCUPANCY_EVICTION_STATUS = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_OCCUPANCY_EVICTION_STATUS/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPOSTAUCT_OCCUPANCY_EVICTION_STATUS = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_OCCUPANCY_EVICTION_STATUS', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePOSTAUCT_OCCUPANCY_EVICTION_STATUS = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_OCCUPANCY_EVICTION_STATUS', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["1"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("1","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["1"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("1","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  

const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["1"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_2"]=value;
	Form_Data_onChange("1","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
  }; 
  


const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["1"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_3"]=value;
	Form_Data_onChange("1","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
  }; 
  


const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["2"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_0"]=value;
	Form_Data_onChange("2","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
  }; 
  

  
      
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["2"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("2","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  


  
      
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["2"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("2","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  


    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["3"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("3","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["3"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("3","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["3"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("3","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["4"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("4","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  

const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["4"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_1"]=value;
	Form_Data_onChange("4","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
  }; 
  

    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["5"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("5","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["5"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("5","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["5"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("5","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["5"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("5","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  

const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["5"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_4"]=value;
	Form_Data_onChange("5","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
  }; 
  

    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["5"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("5","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  

const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["9"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_0"]=value;
	Form_Data_onChange("9","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
  }; 
  

    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["9"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("9","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["9"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("9","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["9"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("9","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  
    
const POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
	Temp_Data["9"]["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4"]=value;
	//handleAddPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data,App_Data['POSTAUCT_OCCUPANCY_EVICTION_STATUS']);
	Form_Data_onChange("9","POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
    setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!POSTAUCT_OCCUPANCY_EVICTION_STATUS) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPOSTAUCT_OCCUPANCY_EVICTION_STATUS =JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
  updatedPOSTAUCT_OCCUPANCY_EVICTION_STATUS[Sec] = [...updatedPOSTAUCT_OCCUPANCY_EVICTION_STATUS[Sec], newRow];
  setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(updatedPOSTAUCT_OCCUPANCY_EVICTION_STATUS);
};

const handleDeleteRow = (sec,index) => {
  const updatedPOSTAUCT_OCCUPANCY_EVICTION_STATUS = JSON.parse(JSON.stringify(POSTAUCT_OCCUPANCY_EVICTION_STATUS));
  updatedPOSTAUCT_OCCUPANCY_EVICTION_STATUS[sec].splice(index, 1);
  setPOSTAUCT_OCCUPANCY_EVICTION_STATUS(updatedPOSTAUCT_OCCUPANCY_EVICTION_STATUS);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Post-Auction Occupancy and Eviction Status`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Post-Auction Occupancy/Eviction ID`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Occupancy Eviction ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0" type="text" className="form-control" placeholder="POSTAUCT Occupancy Eviction ID" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["1"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Occupancy Eviction ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1" type="text" className="form-control" placeholder="Asset ID" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["1"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Occupancy Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_2"  value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["1"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_2`]} onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_2_Change} className="form-control" name="Occupancy Status"  >
						  <option value="Vacant">Vacant</option>
						  <option value="Occupied by Owner">Occupied by Owner</option>
						  <option value="Occupied by Tenant">Occupied by Tenant</option>
						  <option value="Unknown Occupant">Unknown Occupant</option>
						  <option value="Trespasser / Squatter">Trespasser / Squatter</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Occupancy Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Eviction Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_3"  value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["1"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_3`]} onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_1_3_Change} className="form-control" name="Eviction Risk"  >
						  <option value="None">None</option>
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Eviction Risk
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Tenant or Occupant Type`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Tenant Or Occupant Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_0"  value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["2"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_0`]} onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_0_Change} className="form-control" name="Tenant Or Occupant Type"  >
						  <option value="None">None</option>
						  <option value="Owner">Owner</option>
						  <option value="Tenant">Tenant</option>
						  <option value="Unknown Occupant">Unknown Occupant</option>
						  <option value="Commercial Tenant">Commercial Tenant</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Tenant Or Occupant Type
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Legal Possession Confirmed`)} <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1_Change} 
					  checked={POSTAUCT_OCCUPANCY_EVICTION_STATUS?.["2"]?.["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1"] === "true" || POSTAUCT_OCCUPANCY_EVICTION_STATUS?.["2"]?.["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Eviction Required`)} <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2_Change} 
					  checked={POSTAUCT_OCCUPANCY_EVICTION_STATUS?.["2"]?.["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2"] === "true" || POSTAUCT_OCCUPANCY_EVICTION_STATUS?.["2"]?.["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_2_2"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Estimated Eviction Cost USD`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated Eviction Cost USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0" type="text" className="form-control" placeholder="Estimated Eviction Cost USD" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["3"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Estimated Eviction Cost USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated Eviction Timeline Days`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1" type="text" className="form-control" placeholder="Estimated Eviction Timeline Days" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["3"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Estimated Eviction Timeline Days`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Eviction Counsel ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2" type="text" className="form-control" placeholder="Eviction Counsel ID" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["3"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Eviction Counsel ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Occupancy Report Link`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Occupancy Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0" type="text" className="form-control" placeholder="Occupancy Report Link" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["4"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Occupancy Report Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Occupancy Clearance Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_1"  value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["4"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_1`]} onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_4_1_Change} className="form-control" name="Occupancy Clearance Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Cleared">Cleared</option>
						  <option value="Eviction Required">Eviction Required</option>
						  <option value="Blocked">Blocked</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Occupancy Clearance Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0" type="text" className="form-control" placeholder="Submitted By" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["5"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1" type="text" className="form-control" placeholder="Submitted At" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["5"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2" type="text" className="form-control" placeholder="Reviewed By" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["5"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3" type="text" className="form-control" placeholder="Reviewed At" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["5"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_4"  value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["5"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_4`]} onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5" type="text" className="form-control" placeholder="Approval Notes" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["5"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_0"  value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["9"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_0`]} onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1" type="text" className="form-control" placeholder="Created By" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["9"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2" type="text" className="form-control" placeholder="Created At" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["9"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3" type="text" className="form-control" placeholder="Updated By" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["9"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4" type="text" className="form-control" placeholder="Updated At" value={POSTAUCT_OCCUPANCY_EVICTION_STATUS["9"][`POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4`]} 
						onChange={POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_03_PROPERTY_CONTROL_CONDITION_REHAB_APPRAISAL_POSTAUCT_OCCUPANCY_EVICTION_STATUS_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default POSTAUCT_Occupancy_Eviction_Status;  